import {
  renameParcelasCompraUIDD,
  renameItensUIDD,
  getSubTotal,
  getTotalCompra,
  TIPO_COMPRA_MERCADORIAS_REVENDA,
} from '../../../../utils';

function somaRepasses(dados) {
  let soma = 0;
  soma += dados.repasse_ipi;
  soma += dados.repasse_frete;
  soma += dados.repasse_st;
  soma += dados.repasse_seguros;
  soma += dados.repasse_outras_despesas;
  return soma;
}

function calculaTotais(lotes) {
  let subTotalProdutos = 0;
  let total_repasse_ipi = 0;
  let total_repasse_frete = 0;
  let total_repasse_st = 0;
  let total_repasse_seguros = 0;
  let total_repasse_outras_despesas = 0;
  let total_desconto_nfe = 0;
  let subTotalPresumido = 0;
  for (let i = 0; i < lotes.length; i++) {
    const lote = lotes[i];
    subTotalProdutos += getTotalCompra(
      lote.peso,
      lote.unidades,
      lote.unitario,
      lote.produto,
    );
    subTotalPresumido += getTotalCompra(
      lote.peso,
      lote.unidades,
      lote.unitarioImpostoPresumido,
      lote.produto,
    );
    total_repasse_ipi += getTotalCompra(
      lote.peso,
      lote.unidades,
      lote.dadosPrecificacao ? lote.dadosPrecificacao.repasse_do_ipi : 0,
      lote.produto,
    );
    total_repasse_frete += getTotalCompra(
      lote.peso,
      lote.unidades,
      lote.dadosPrecificacao ? lote.dadosPrecificacao.repasse_do_frete : 0,
      lote.produto,
    );
    total_repasse_st += getTotalCompra(
      lote.peso,
      lote.unidades,
      lote.dadosPrecificacao ? lote.dadosPrecificacao.repasse_de_st : 0,
      lote.produto,
    );
    total_repasse_seguros += getTotalCompra(
      lote.peso,
      lote.unidades,
      lote.dadosPrecificacao ? lote.dadosPrecificacao.repasse_do_seguro : 0,
      lote.produto,
    );
    total_repasse_outras_despesas += getTotalCompra(
      lote.peso,
      lote.unidades,
      lote.dadosPrecificacao
        ? lote.dadosPrecificacao.repasse_de_outras_despesas
        : 0,
      lote.produto,
    );
    total_desconto_nfe += getTotalCompra(
      lote.peso,
      lote.unidades,
      lote.dadosPrecificacao ? lote.dadosPrecificacao.desconto_em_nfe : 0,
      lote.produto,
    );
  }
  return {
    subTotalProdutos,
    total_repasse_ipi,
    total_repasse_frete,
    total_repasse_st,
    total_repasse_seguros,
    total_repasse_outras_despesas,
    total_desconto_nfe,
    subTotalPresumido,
  };
}

const reducer = (state, action) => {
  let arrayNew = state.lotes.slice();
  let arrayNewParcelas = state.parcelas.slice();
  switch (action.type) {
    case 'ADD_LOTE': {
      const newArray = [...arrayNew, action.lote];
      const {
        subTotalProdutos,
        total_repasse_ipi,
        total_repasse_frete,
        total_repasse_st,
        total_repasse_seguros,
        total_repasse_outras_despesas,
        subTotalPresumido,
        total_desconto_nfe,
      } = calculaTotais(newArray);
      return {
        ...state,
        lotes: [...arrayNew, action.lote],
        subTotal: getSubTotal(newArray) + somaRepasses(state),
        subTotalProdutos,
        total_repasse_ipi,
        total_repasse_frete,
        total_repasse_st,
        total_repasse_seguros,
        total_repasse_outras_despesas,
        subTotalPresumido,
        total_desconto_nfe,
      };
    }
    case 'REMOVE_LOTE': {
      for (let i = 0; i < action.indices.length; i += 1) {
        arrayNew = arrayNew.filter((obj) => obj.uidd !== action.indices[i]);
      }
      const {
        subTotalProdutos,
        total_repasse_ipi,
        total_repasse_frete,
        total_repasse_st,
        total_repasse_seguros,
        total_repasse_outras_despesas,
        subTotalPresumido,
        total_desconto_nfe,
      } = calculaTotais(arrayNew);
      return {
        ...state,
        lotes: [...renameItensUIDD(arrayNew)],
        subTotal: getSubTotal([...arrayNew]) + somaRepasses(state),
        subTotalProdutos,
        total_repasse_ipi,
        total_repasse_frete,
        total_repasse_st,
        total_repasse_seguros,
        total_repasse_outras_despesas,
        subTotalPresumido,
        total_desconto_nfe,
      };
    }
    case 'UPDATE_LOTE': {
      const index = arrayNew.findIndex(
        (item) => item.uidd === action.lote.index,
      );
      if (index >= 0) {
        arrayNew[index] = {
          ...arrayNew[index],
          produto: action.lote.produto,
          peso: action.lote.peso,
          total: action.lote.total,
          unidades: action.lote.unidades,
          unitario: action.lote.unitario,
          validade: action.lote.validade,
          unitarioImposto: action.lote.unitarioImposto,
          cg: action.lote.cg,
          dadosPrecificacao: action.lote.dadosPrecificacao,
          nImpressoes: action.lote.nImpressoes,
          validades: action.lote.validades,
          unitarioPresumido: action.lote.unitarioPresumido,
          unitarioImpostoPresumido: action.lote.unitarioImpostoPresumido,
          totalPresumido: action.lote.totalPresumido,
          pallets: action.lote.pallets,
        };
        const {
          subTotalProdutos,
          total_repasse_ipi,
          total_repasse_frete,
          total_repasse_st,
          total_repasse_seguros,
          total_repasse_outras_despesas,
          subTotalPresumido,
          total_desconto_nfe,
        } = calculaTotais(arrayNew);
        return {
          ...state,
          lotes: [...renameItensUIDD(arrayNew)],
          subTotal: getSubTotal([...arrayNew]) + somaRepasses(state),
          subTotalProdutos,
          total_repasse_ipi,
          total_repasse_frete,
          total_repasse_st,
          total_repasse_seguros,
          total_repasse_outras_despesas,
          subTotalPresumido,
          total_desconto_nfe,
        };
      }
      return {
        ...state,
      };
    }
    case 'UPDATE_LOTES': {
      const {
        subTotalProdutos,
        total_repasse_ipi,
        total_repasse_frete,
        total_repasse_st,
        total_repasse_seguros,
        total_repasse_outras_despesas,
        subTotalPresumido,
        total_desconto_nfe,
      } = calculaTotais(action.lotes);
      return {
        ...state,
        lotes: [...renameItensUIDD(action.lotes)],
        subTotal: getSubTotal([...action.lotes]) + somaRepasses(state),
        subTotalProdutos,
        total_repasse_ipi,
        total_repasse_frete,
        total_repasse_st,
        total_repasse_seguros,
        total_repasse_outras_despesas,
        subTotalPresumido,
        total_desconto_nfe,
      };
    }

    case 'UPDATE_TIPO_COMPRA':
      return {
        ...state,
        tipo: action.tipo,
      };

    case 'UPDATE_FORNECEDOR':
      return {
        ...state,
        fornecedor: action.fornecedor,
      };

    case 'UPDATE_NUMERO_NOTA_FISCAL':
      return {
        ...state,
        numeroNotaFiscal: action.numeroNotaFiscal,
      };

    case 'UPDATE_DATA_FATURAMENTO':
      return {
        ...state,
        data_faturamento: action.data_faturamento,
      };

    case 'ADD_PARCELA':
      return {
        ...state,
        parcelas: [...arrayNewParcelas, action.parcela],
      };
    case 'UPDATE_PARCELA': {
      const index = arrayNewParcelas.findIndex(
        (item) => item.uidd === action.parcela.index,
      );
      if (index >= 0) {
        arrayNewParcelas[index] = {
          ...arrayNewParcelas[index],
          data_pagamento: action.parcela.data_pagamento,
          conta: action.parcela.conta,
          valor: action.parcela.valor,
          idIndicadorChange: action.parcela.idIndicadorChange,
          status: action.parcela.status,
          cartao: action.parcela.cartao,
          isCartao: action.parcela.isCartao,
          fatura: action.parcela.fatura,
          codigo_boleto: action.parcela.codigo_boleto,
          problema: action.parcela.problema,
          descricao_problema: action.parcela.descricao_problema,
          agendamento_user_id: action.parcela.agendamento_user_id,
          desconto: action.parcela.desconto,
          tarifa_boleto: action.parcela.tarifa_boleto,
          arquivoBoleto: action.parcela.arquivoBoleto,
          link_boleto_pdf: action.parcela.link_boleto_pdf,
          pix_copia_e_cola: action.parcela.pix_copia_e_cola,
          tipo_pagamento: action.parcela.tipo_pagamento,
        };
        return {
          ...state,
          parcelas: [...renameParcelasCompraUIDD(arrayNewParcelas)],
        };
      }
      return {
        ...state,
      };
    }
    case 'REMOVE_PARCELA':
      for (let i = 0; i < action.indices.length; i += 1) {
        arrayNewParcelas = arrayNewParcelas.filter(
          (obj) => obj.uidd !== action.indices[i],
        );
      }
      return {
        ...state,
        parcelas: [...renameParcelasCompraUIDD(arrayNewParcelas)],
      };
    case 'UPDATE_PARCELAS':
      return {
        ...state,
        parcelas: [...renameParcelasCompraUIDD(action.parcelas)],
      };

    case 'UPDATE_ID_EDIT':
      return {
        ...state,
        idEdit: action.idEdit,
      };

    case 'UPDATE_LOJA':
      return {
        ...state,
        loja: action.loja,
      };

    case 'RESETAR_TUDO':
      return {
        ...state,
        idEdit: -1,
        lotes: [],
        parcelas: [],
        subTotal: 0,
        fornecedor: null,
        numeroNotaFiscal: '',
        data_faturamento: '',
        data_criacao: new Date(),
        loja: {
          nome: 'CARUARU FRIOS',
          value: 'CF',
        },
        repasse_ipi: 0,
        repasse_frete: 0,
        repasse_st: 0,
        repasse_seguros: 0,
        repasse_outras_despesas: 0,
        numeroCompra: '-',
        total_repasse_ipi: 0,
        total_repasse_frete: 0,
        total_repasse_st: 0,
        total_repasse_seguros: 0,
        total_repasse_outras_despesas: 0,
        subTotalProdutos: 0,
        isProdutosSomenteFornecedor: true,
        isIncluiInativos: false,
        serieNotaFiscal: '',
        chaveAcessoNotaFiscal: '',
        isImportacaoXml: false,
        tipo: TIPO_COMPRA_MERCADORIAS_REVENDA,
        uf: '',
        dadosXml: null,
        subTotalPresumido: 0,
        total_desconto_nfe: 0,
        total_desconto_descarrego: 0,
      };

    case 'PREENCHER_TUDO': {
      const {
        subTotalProdutos,
        total_repasse_ipi,
        total_repasse_frete,
        total_repasse_st,
        total_repasse_seguros,
        total_repasse_outras_despesas,
        subTotalPresumido,
        total_desconto_nfe,
      } = calculaTotais(action.lotes);
      return {
        ...state,
        idEdit: action.idEdit,
        lotes: [...renameItensUIDD(action.lotes)],
        subTotal: getSubTotal([...action.lotes]) + somaRepasses(action),
        parcelas: [...renameParcelasCompraUIDD(action.parcelas)],
        fornecedor: action.fornecedor,
        numeroNotaFiscal: action.numeroNotaFiscal,
        data_faturamento: action.data_faturamento,
        data_criacao: action.data_criacao,
        loja: action.loja,
        repasse_ipi: action.repasse_ipi,
        repasse_frete: action.repasse_frete,
        repasse_st: action.repasse_st,
        repasse_seguros: action.repasse_seguros,
        repasse_outras_despesas: action.repasse_outras_despesas,
        carregando: action.carregando,
        config: action.config,
        numeroCompra: action.numeroCompra,
        subTotalProdutos,
        total_repasse_ipi,
        total_repasse_frete,
        total_repasse_st,
        total_repasse_seguros,
        total_repasse_outras_despesas,
        isProdutosSomenteFornecedor: true,
        isIncluiInativos: false,
        serieNotaFiscal: action.serieNotaFiscal,
        chaveAcessoNotaFiscal: action.chaveAcessoNotaFiscal,
        isImportacaoXml: action.isImportacaoXml,
        tipo: action.tipo,
        uf: action.uf,
        dadosXml: action.dadosXml,
        subTotalPresumido,
        total_desconto_nfe,
        total_desconto_descarrego: action.total_desconto_descarrego,
      };
    }
    case 'UPDATE_DADOS_TELA_INICIAL': {
      const {
        subTotalProdutos,
        total_repasse_ipi,
        total_repasse_frete,
        total_repasse_st,
        total_repasse_seguros,
        total_repasse_outras_despesas,
        subTotalPresumido,
        total_desconto_nfe,
      } = calculaTotais(state.lotes);
      return {
        ...state,
        subTotal: getSubTotal([...state.lotes]) + somaRepasses(action),
        fornecedor: action.fornecedor,
        loja: action.loja,
        numeroNotaFiscal: action.numeroNotaFiscal,
        data_faturamento: action.data_faturamento,
        repasse_frete: action.repasse_frete,
        repasse_ipi: action.repasse_ipi,
        repasse_outras_despesas: action.repasse_outras_despesas,
        repasse_seguros: action.repasse_seguros,
        repasse_st: action.repasse_st,
        subTotalProdutos,
        total_repasse_ipi,
        total_repasse_frete,
        total_repasse_st,
        total_repasse_seguros,
        total_repasse_outras_despesas,
        serieNotaFiscal: action.serieNotaFiscal,
        chaveAcessoNotaFiscal: action.chaveAcessoNotaFiscal,
        subTotalPresumido,
        total_desconto_nfe,
        //isImportacaoXml: action.isImportacaoXml,
      };
    }
    case 'UPDATE_FILTROS_PESQUISA':
      return {
        ...state,
        isProdutosSomenteFornecedor: action.isProdutosSomenteFornecedor,
        isIncluiInativos: action.isIncluiInativos,
      };

    case 'UPDATE_UUID': {
      const dados = {
        ...state,
        uuid: action.uuid,
      };
      return dados;
    }
    default:
      return state;
  }
};

export default reducer;
